import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const SharedPoliciesIllustration = (props: SVGProps) => {
  const {
    title = 'SharedPoliciesIllustration',
    className,
    ...restProps
  } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 246 96"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <g clip-path="url(#clip0_7410_392873)">
        <path d="M62.8013 95.9219H52.5848V102H62.8013V95.9219Z" fill="white" />
        <path d="M129.328 95.9219H119.111V102H129.328V95.9219Z" fill="white" />
        <path
          d="M41.2296 3.30957V97.3282H142.039V3.30957H41.2296ZM132.457 87.6827H50.808V12.2126H132.457V87.6827Z"
          fill="white"
        />
        <path
          d="M133.956 41.9854H49.3929V57.3771H133.956V41.9854Z"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M193.745 76.5629H137.588C126.696 76.5629 117.868 67.7346 117.868 56.8428"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M182.266 -0.000976562H156.251C154.494 -0.000976562 153.069 1.42403 153.069 3.18186V58.4655C153.069 60.2233 154.494 61.6483 156.251 61.6483H182.266C184.024 61.6483 185.449 60.2233 185.449 58.4655V3.18186C185.449 1.42403 184.024 -0.000976562 182.266 -0.000976562Z"
          fill="currentColor"
        />
        <path
          d="M169.26 55.5626C175.548 55.5626 180.645 50.4657 180.645 44.1783C180.645 37.8909 175.548 32.7939 169.26 32.7939C162.973 32.7939 157.876 37.8909 157.876 44.1783C157.876 50.4657 162.973 55.5626 169.26 55.5626Z"
          stroke="black"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M174.003 49.7235V48.7123C174.003 46.0929 171.88 43.9697 169.26 43.9697C166.641 43.9697 164.518 46.0929 164.518 48.7123V49.7235H174.003Z"
          fill="black"
        />
        <path
          d="M169.259 44.1145C170.948 44.1145 172.318 42.7446 172.318 41.0548C172.318 39.365 170.948 37.9951 169.259 37.9951C167.569 37.9951 166.199 39.365 166.199 41.0548C166.199 42.7446 167.569 44.1145 169.259 44.1145Z"
          fill="black"
        />
        <path
          d="M169.26 28.0401C175.548 28.0401 180.645 22.9432 180.645 16.6558C180.645 10.3684 175.548 5.27148 169.26 5.27148C162.973 5.27148 157.876 10.3684 157.876 16.6558C157.876 22.9432 162.973 28.0401 169.26 28.0401Z"
          stroke="black"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M174.003 22.2V21.1888C174.003 18.5694 171.88 16.4463 169.26 16.4463C166.641 16.4463 164.518 18.5694 164.518 21.1888V22.2H174.003Z"
          fill="black"
        />
        <path
          d="M169.259 16.593C170.948 16.593 172.318 15.2232 172.318 13.5333C172.318 11.8435 170.948 10.4736 169.259 10.4736C167.569 10.4736 166.199 11.8435 166.199 13.5333C166.199 15.2232 167.569 16.593 169.259 16.593Z"
          fill="black"
        />
        <path
          d="M60.1882 78.6823C67.0912 78.6823 72.6845 73.0853 72.6845 66.1898C72.6845 59.2943 67.0912 53.6973 60.1882 53.6973H12.1957C5.30014 53.6973 -0.296875 59.2905 -0.296875 66.1898C-0.296875 73.0891 5.30014 78.6823 12.1957 78.6823H60.1882Z"
          fill="currentColor"
        />
        <path
          d="M57.9983 69.041H32.7371"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M57.9983 63.123H32.7371"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M20.6281 72.4252C24.0717 72.4252 26.8632 69.6337 26.8632 66.1902C26.8632 62.7466 24.0717 59.9551 20.6281 59.9551C17.1846 59.9551 14.3931 62.7466 14.3931 66.1902C14.3931 69.6337 17.1846 72.4252 20.6281 72.4252Z"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M23.2239 69.2274V68.6751C23.2239 67.2386 22.0598 66.0781 20.6269 66.0781C19.1941 66.0781 18.0299 67.2423 18.0299 68.6751V69.2274H23.2277H23.2239Z"
          fill="white"
        />
        <path
          d="M20.6292 65.9513C21.5545 65.9513 22.3046 65.2012 22.3046 64.276C22.3046 63.3507 21.5545 62.6006 20.6292 62.6006C19.7039 62.6006 18.9539 63.3507 18.9539 64.276C18.9539 65.2012 19.7039 65.9513 20.6292 65.9513Z"
          fill="white"
        />
        <path
          d="M67.1964 59.1378C73.288 59.1378 78.2262 54.1996 78.2262 48.108C78.2262 42.0164 73.288 37.0781 67.1964 37.0781C61.1047 37.0781 56.1665 42.0164 56.1665 48.108C56.1665 54.1996 61.1047 59.1378 67.1964 59.1378Z"
          fill="white"
        />
        <path
          d="M67.1952 42.9893V53.2318"
          stroke="black"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M72.3176 48.1074H62.0751"
          stroke="black"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M245.277 28.918H194.419V95.7613H245.277V28.918Z"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M201.106 42.6152H211.292"
          stroke="currentColor"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M213.545 61.0596H236.496"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M213.545 69.6377H236.496"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M213.545 78.2197H236.496"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M213.545 86.7979H236.496"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M227.915 44.2238L230.811 47.1194L236.497 41.541"
          stroke="currentColor"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M194.377 7.01758H244.419"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
        <path
          d="M194.377 18.0039H224.075"
          stroke="white"
          stroke-width="1.86567"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_7410_392873">
          <rect
            width="246.504"
            height="102"
            fill="white"
            transform="translate(-0.296875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
